import { apiSlice } from './apiSlice';

export const cartApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActiveCart: builder.query({
      query: () => {
        return {
          url: '/api/v2/cart',
          method: 'GET',
        };
      },
      transformResponse: (response) => {
        // Transform API response to match UI structure
        console.log('Raw API response for active cart:', response);
        const items = response?.items || [];
        
        return {
          items: items.map((item) => ({
            id: item.id || item.product?.id,
            title: item.product?.name,
            author: item.product?.vendorName,
            edition: item.edition?.name,
            image: item.product?.iconUrl,
            storefrontUrl: item.product?.storefrontUrl
          })),
        };
      },
      providesTags: ['ActiveCart'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetActiveCartQuery, useLazyGetActiveCartQuery } = cartApi;
